import App from '@/models/App'

export default class TrafficShipRecordComment extends App {
    static get entity() {
        return 'TrafficShipRecordComments'
    }
    static all() {
        return this.query().orderBy('createdAt', 'desc').get()
    }
    static fields() {
        return {
            id: this.attr(''),
            userId: this.attr(''),
            parentType: this.attr(''),
            parentId: this.attr(''),
            comment: this.attr(''),
            user: this.attr({}),
            isMine: this.attr(false),
            createdAt: this.attr(''),
        }
    }
    static apiConfig = {
        actions: {
            fetch(trafficShipRecordId, params) {
                return this.get(
                    `traffic/ship/records/${trafficShipRecordId}/comments`,
                    {
                        params: App.get(params),
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        dataKey: 'data',
                        baseURL: App.apiURL(),
                    }
                )
            },
            create(trafficShipRecordId, params) {
                return this.post(
                    `/traffic/ship/records/${trafficShipRecordId}/comments`,
                    App.post(params),
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        baseURL: App.apiURL(),
                    }
                )
            },
            update(trafficShipRecordId, trafficCommentId, params) {
                return this.patch(
                    `/traffic/ship/records/${trafficShipRecordId}/comments/${trafficCommentId}`,
                    App.patch(params),
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        baseURL: App.apiURL(),
                    }
                )
            },
            destroy(trafficShipRecordId, trafficCommentId) {
                return this.delete(
                    `traffic/ship/records/${trafficShipRecordId}/comments/${trafficCommentId}`,
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        delete: trafficCommentId,
                        baseURL: App.apiURL(),
                    }
                )
            },
        },
    }
}
